export const slaApi = (client) => ({
    list: () => client.get('/api/v1/sla-policies').then((r) => r.data),
    get: (id) => client.get(`/api/v1/sla-policies/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/sla-policies', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/sla-policies/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/sla-policies/${id}`).then((r) => r.data),
    applyToExisting: () => client.post('/api/v1/sla-policies/apply-existing').then((r) => r.data),
});
//# sourceMappingURL=sla.js.map